/* Category chips: toggles edge-fade masks depending on scroll position. */
class CategoryChips extends HTMLElement {
  connectedCallback() {
    this.row = this.querySelector('[data-chip-row]');
    if (!this.row) return;
    this.update = this.update.bind(this);
    this.row.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);
    this.update();
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.update);
  }
  update() {
    const r = this.row;
    const max = r.scrollWidth - r.clientWidth;
    this.toggleAttribute('data-at-start', r.scrollLeft <= 4);
    this.toggleAttribute('data-at-end', max <= 4 || r.scrollLeft >= max - 4);
  }
}
if (!customElements.get('category-chips')) customElements.define('category-chips', CategoryChips);
